import React, { useEffect } from 'react'

export function Sidebar({ open, onToggle, activeView, onViewChange, views }) {
  useEffect(() => {
    const handleViewChange = (e) => onViewChange(e.detail)
    const handleSidebarToggle = () => onToggle()
    window.addEventListener('view-change', handleViewChange)
    window.addEventListener('sidebar-toggle', handleSidebarToggle)
    return () => {
      window.removeEventListener('view-change', handleViewChange)
      window.removeEventListener('sidebar-toggle', handleSidebarToggle)
    }
  }, [onViewChange, onToggle])

  return (
    <aside className={`sidebar ${open ? 'open' : 'collapsed'}`} role="navigation" aria-label="Main navigation">
      <nav className="sidebar-nav" aria-label="Views">
        <ul>
          {views.map(view => (
            <li key={view.id}>
              <button
                role="menuitem"
                aria-selected={activeView === view.id}
                className={`nav-item ${activeView === view.id ? 'active' : ''}`}
                onClick={() => onViewChange(view.id)}
                title={view.label}
              >
                <span className="nav-icon">{view.icon}</span>
                {open && <span className="nav-label">{view.label}</span>}
              </button>
            </li>
          ))}
        </ul>
      </nav>
      <div className="sidebar-footer">
        <button className="collapse-btn" onClick={onToggle} aria-label={open ? 'Collapse sidebar' : 'Expand sidebar'}>
          {open ? (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="15 18 9 12 15 6"></polyline>
            </svg>
          ) : (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="9 18 15 12 9 6"></polyline>
            </svg>
          )}
        </button>
      </div>
      <style jsx>{`
        .sidebar {
          width: 260px;
          min-width: 260px;
          background: var(--surface-1);
          border-right: 1px solid var(--border);
          display: flex;
          flex-direction: column;
          transition: width 0.2s ease, min-width 0.2s ease;
          overflow: hidden;
        }
        .sidebar.collapsed {
          width: 64px;
          min-width: 64px;
        }
        .sidebar-nav {
          flex: 1;
          padding: 16px 8px;
          overflow-y: auto;
        }
        .sidebar-nav ul {
          list-style: none;
          display: flex;
          flex-direction: column;
          gap: 4px;
        }
        .nav-item {
          display: flex;
          align-items: center;
          gap: 12px;
          width: 100%;
          padding: 12px 16px;
          border-radius: 8px;
          color: var(--text-secondary);
          font-weight: 500;
          font-size: 14px;
          white-space: nowrap;
          transition: all 0.15s;
        }
        .nav-item:hover {
          background: var(--page-plane);
          color: var(--text-primary);
        }
        .nav-item.active {
          background: var(--series-1);
          color: white;
        }
        .nav-item.active .nav-icon {
          color: white;
        }
        .nav-icon {
          font-size: 18px;
          width: 24px;
          text-align: center;
          flex-shrink: 0;
        }
        .nav-label {
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .sidebar-footer {
          padding: 12px;
          border-top: 1px solid var(--border);
        }
        .collapse-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 40px;
          border-radius: 8px;
          color: var(--text-secondary);
          background: var(--page-plane);
        }
        .collapse-btn:hover {
          background: var(--border);
          color: var(--text-primary);
        }
        .sidebar.collapsed .nav-label {
          display: none;
        }
        .sidebar.collapsed .nav-item {
          justify-content: center;
          padding: 12px;
        }
      `}</style>
    </aside>
  )
}